import { render, staticRenderFns } from "./fccInstituicao.vue?vue&type=template&id=0e1e1374"
import script from "./fccInstituicao.vue?vue&type=script&lang=js"
export * from "./fccInstituicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports